import type { ReactNode } from 'react';

/**
 * The three columns of the creation form and of the « Configuration » tab
 * (mockups « F1 » and « U1 », 2026-10-16): a list on the left (the steps,
 * the environments), the cards in the middle, the side panel on the right.
 *
 * Laid out by container queries on its own width (`.waadoo-workbench`,
 * styles.css), so it follows the room the page leaves it rather than the
 * window: three columns when wide enough, the panel under the cards when
 * not, and the list on top of everything when even two columns do not fit.
 *
 * The middle and the right are given either as `main` and `aside`, or as
 * children made of `WorkbenchMain` and `WorkbenchAside` — for a component
 * that renders both from one state (the « Configuration » tab's editor)
 * while the list stays mounted beside it.
 */
export function Workbench(props: {
  nav: ReactNode;
  main?: ReactNode;
  aside?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={['waadoo-workbench', props.className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="waadoo-workbench__grid">
        <div className="waadoo-workbench__nav">{props.nav}</div>
        {props.main !== undefined && (
          <WorkbenchMain>{props.main}</WorkbenchMain>
        )}
        {props.aside !== undefined && (
          <WorkbenchAside>{props.aside}</WorkbenchAside>
        )}
        {props.children}
      </div>
    </div>
  );
}

/** The middle column of `Workbench`. */
export function WorkbenchMain(props: { children: ReactNode }) {
  return <div className="waadoo-workbench__main">{props.children}</div>;
}

/** The right column of `Workbench`. */
export function WorkbenchAside(props: { children: ReactNode }) {
  return <div className="waadoo-workbench__aside">{props.children}</div>;
}
